import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  computed,
  output
} from '@angular/core';
import { ChatAdminService } from '../../../services/chat-admin.service';
import { ChatAuthService } from '../../../services/chat-auth.service';
import type { QuoteMessage } from '../../chat/chat.component';
import moment from 'moment';

@Component({
  selector: 'app-quoted-message-card',
  templateUrl: './quoted-message-card.component.html',
  styleUrls: ['./quoted-message-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class QuotedMessageCardComponent implements OnInit {
  @ViewChild('quotecitebody') quoteCitedBody: ElementRef;

  // Signal-based inputs
  quoteMessage = input.required<QuoteMessage>();
  dateTimeLocale = input<string>();
  previewMode = input<boolean>(false);

  // Signal-based output
  loadQuotedMessage = output<any>();

  // Computed signals for date/time formatting
  quoteDate = computed(() => {
    const message = this.quoteMessage();
    if (message?.cite?.createdOn) {
      return moment(message.cite.createdOn).format('MM/DD');
    }
    return '';
  });

  quoteTime = computed(() => {
    const message = this.quoteMessage();
    if (message?.cite?.createdOn) {
      return moment(message.cite.createdOn).format('LT');
    }
    return '';
  });

  quoteDateToday = computed(() => {
    const message = this.quoteMessage();
    if (message?.cite?.createdOn) {
      return moment(message.cite.createdOn).isSame(moment(), 'day');
    }
    return false;
  });

  maxChatMessageWidth = computed(() => {
    return this.previewMode() ? 'calc(90% - 1.6875rem)' : '90%';
  });
  constructor(
    public chatAuthService: ChatAuthService,
    public chatAdminService: ChatAdminService,
    private cdRef: ChangeDetectorRef
  ) {}

  markForCheck(): void {
    this.cdRef.markForCheck();
  }

  ngOnInit(): void {
    // Date/time computation moved to computed signals
    // No initialization needed here
  }

  goToQuotedMessage() {
    this.loadQuotedMessage.emit(undefined);
  }

  public getChatMessageMaxWidth(): string {
    return this.maxChatMessageWidth();
  }
}
